module.exports = __webpack_public_path__ + "img/ico_dog.2bb04cf9.svg";